export default __webpack_public_path__ + "static/media/lumen-dashboard-banner-2.bd400f76.svg";